/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { authWatcher } from "./auth/saga";
import { connectorWatcher } from "./connector/saga";
import { collectorWatcher } from "./collector/saga";
import { datapipeWatcher } from "./datapipe/saga";
import { aggregateWatcher } from "./aggregate/saga";
import { playerWatcher } from "./player/saga";
import { companyWatcher } from "./company/saga";
import { userWatcher } from "./user/saga";
import { analyticWatcher } from "./analytic/saga";
import { notificationWatcher } from "./notification/saga";
import { apiKeyWatcher } from "./customer/saga";
import { dataDictionaryWatcher } from "./datadictionary/saga";
import { projectWatcher } from "./project/saga";
import { uiWatcher } from "./ui/saga";
import { customDataWatcher } from "./customdata/saga";
import { collectorMgmtWatcher } from "./collectorMgmt/saga";

const sagas = {
  authWatcher,
  connectorWatcher,
  datapipeWatcher,
  collectorWatcher,
  aggregateWatcher,
  playerWatcher,
  companyWatcher,
  userWatcher,
  analyticWatcher,
  notificationWatcher,
  apiKeyWatcher,
  dataDictionaryWatcher,
  projectWatcher,
  uiWatcher,
  customDataWatcher,
  collectorMgmtWatcher,
};

export function registerWithMiddleware(middleware) {
  Object.keys(sagas).forEach((name) => {
    middleware.run(sagas[name]);
  });
}
